export default function NeedsFund({fund, children}){
    if(!fund) return <div></div>
    return children
}